import { useHomePageFeature } from '@/hooks/featureFlags';
import { useRecordRecentVisit } from '@/hooks/home/useRecordRecentVisit';
import { Entity } from '@/types/entity';

const RecordRecentVisitBase = ({ type }: { type: Entity }) => {
  useRecordRecentVisit(type);
  return null;
};

export const RecordRecentVisit = ({ type }: { type: Entity }) =>
  useHomePageFeature() ? <RecordRecentVisitBase type={type} /> : null;
